import React from 'react';
import { useTranslation } from 'react-i18next';
import Cart3D from '../../assets/cart_3d.png'; // We'll replace this with a more appropriate icon later

interface CatalogueEmptyStateProps {
  onUploadMenu: () => void;
  onAddManually: () => void;
}

const CatalogueEmptyState: React.FC<CatalogueEmptyStateProps> = ({
  onUploadMenu,
  onAddManually,
}) => {
  const { t } = useTranslation(['catalogue']);

  return (
    <div className='flex justify-center items-center h-auto mt-24'>
      <div className='text-center'>
        <p className='text-2xl mx-8 text-gray-400'>
          {t('no_products.label', 'No products in your catalogue yet')}
        </p>

        <img
          className='mx-auto opacity-40 my-8'
          src={Cart3D}
          alt='Empty Menu'
        />

        <div className='flex flex-col md:flex-row gap-4 justify-center'>
          <button
            onClick={onUploadMenu}
            className='px-6 py-3 bg-droov text-white rounded-full hover:bg-droov/90 transition duration-300 hover:bg-droov_dark flex items-center justify-center'
          >
            {t('upload_menu.button', 'Upload your menu')}
          </button>
        </div>

        <p className='text-sm text-gray-500 mt-6'>
          {t(
            'empty_state_tip.text',
            'Upload your menu and let our AI automatically create catalogue items for you'
          )}
        </p>
        <div className='mt-5'>
          <button
            onClick={onAddManually}
            className='mx-auto px-4 py-2 bg-transparent text-gray-500 rounded-full hover:border-gray-600 duration-200 transition-colors ease-in-out border-transparent border text-sm flex justify-center items-center'
          >
            {t('add_manually.button', 'Add products manually')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CatalogueEmptyState;
